<template>
  <div v-if="!latestTalkShows || !latestTalkShows[0]" class="scheduleListBlock">
    <div class="scheduleListBody">
      <div class="scheduleInfo">
        <h4>予定されているトークショーはありません</h4>
      </div>
    </div>
  </div>
  <div v-else class="scheduleListBlock">
      <div class="scheduleListBody">
        <div class="scheduleInfo">
          <h4>{{dispSchedule(latestTalkShows[0])}}</h4>
          <div class="scheduleInfoBody">
            <div class="scheduleImg">
              <a href="javascript:void(0);" @click="openLink(latestTalkShows[0])"><img :class="{clickable: isOnAir(latestTalkShows[0])}" alt="" :src="latestTalkShows[0].thumbnail" /></a>
              <p v-if="isOnAir(latestTalkShows[0])" class="status">On AIR</p>
            </div><!-- /scheduleImg-->
            <p class="cName">{{latestTalkShows[0].clients}}</p>
            <h5>{{latestTalkShows[0].title}}</h5>
            <div class="scheduleAbout">
              <p class="guest">ゲスト：{{latestTalkShows[0].speakers}}</p>
              <p class="txt">{{latestTalkShows[0].description}}</p>
            </div><!-- /scheduleImg-->
            <div class="scheduleButton" v-if="isOnAir(latestTalkShows[0])">
              <a href="javascript:void(0);" class="StandardBtn onAir" @click="openLink(latestTalkShows[0])">ON AIR中&nbsp;&nbsp;ライブ配信を見る</a>
            </div>
          </div><!-- /scheduleInfoBody-->
        </div><!-- /scheduleInfo-->
      </div><!-- /scheduleListBody-->
      <div class="scheduleListBody">
        <div v-if="latestTalkShows[1]" class="scheduleInfo">
          <h4>{{dispSchedule(latestTalkShows[1])}}</h4>
          <div class="scheduleInfoBody">
            <div class="scheduleImg">
              <a href="javascript:void(0)" @click="openLink(latestTalkShows[1])"><img :class="{clickable: isOnAir(latestTalkShows[1])}" alt="" :src="latestTalkShows[1].thumbnail" /></a>
              <p v-if="isOnAir(latestTalkShows[1])" class="status">On AIR</p>
            </div><!-- /scheduleImg-->
            <p class="cName">{{latestTalkShows[1].clients}}</p>
            <h5>{{latestTalkShows[1].title}}</h5>
            <div class="scheduleAbout">
              <p class="guest">ゲスト：{{latestTalkShows[1].speakers}}</p>
              <p class="txt">{{latestTalkShows[1].description}}</p>
            </div><!-- /scheduleImg-->
            <div class="scheduleButton" v-if="isOnAir(latestTalkShows[1])">
              <a href="javascript:void(0);" class="StandardBtn onAir" @click="openLink(latestTalkShows[1])">ON AIR中&nbsp;&nbsp;ライブ配信を見る</a>
            </div>
          </div><!-- /scheduleInfoBody-->
        </div><!-- /scheduleInfo-->
      </div><!-- /scheduleListBody-->
    </div>
</template>

<script>
import moment from 'moment-timezone'
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      latestTalkShows: [],
      nowDateTime: null
    }
  },
  created () {
    this.setNow()
    this.setLatestTalkShows()
  },
  methods: {
    // 現在時刻のセット
    setNow () {
      this.nowDateTime = moment().tz('Asia/Tokyo').format('YYYYMMDD HH:mm:ss')
      setInterval(function () {
        this.nowDateTime = moment().tz('Asia/Tokyo').format('YYYYMMDD HH:mm:ss')
      }.bind(this), 1000)
    },
    setLatestTalkShows () {
      this.latestTalkShows = this.getLatestTalkShows()
      // リストの詰め替えは30秒ごと
      setInterval(function () {
        this.latestTalkShows = this.getLatestTalkShows()
      }.bind(this), 30000)
    },
    getLatestTalkShows () {
      let cnt = 0
      const results = []
      for (const talkShow of this.talkShows) {
        if (this.nowDateTime > moment(talkShow.endTime, 'YYYY-MM-DD HH:mm:ss').tz('Asia/Tokyo').format('YYYYMMDD HH:mm:ss')) {
          continue
        }
        results.push(talkShow)
        cnt += 1
        if (cnt >= 2) {
          break
        }
      }
      return results
    },
    // トークショーが終了している場合falseを返す
    isOnAir (talkShow) {
      if (this.nowDateTime < moment(talkShow.startTime).tz('Asia/Tokyo').format('YYYYMMDD HH:mm:ss')) {
        return false
      }
      if (this.nowDateTime > moment(talkShow.endTime).tz('Asia/Tokyo').format('YYYYMMDD HH:mm:ss')) {
        return false
      }
      return true
    },
    openLink (talkShow) {
      if (this.isOnAir(talkShow)) {
        if (!talkShow.liveLink) {
          window.open('https://www.instagram.com/tokyocameraclub/', '_blank')
        } else {
          window.open(talkShow.liveLink, '_blank')
        }
      }
    },
    dispSchedule (talkShow) {
      const start = moment(talkShow.startTime).tz('Asia/Tokyo').format('M月D日 HH:mm')
      const end = moment(talkShow.endTime).tz('Asia/Tokyo').format('HH:mm')
      return start + '~' + end
    }
  },
  computed: {
    ...mapGetters([
      'talkShows'
    ])
  },
  mounted () {
    // vuexへの読み込み状態を監視し、読み込まれたら表示を更新する
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'setTalkShows') {
        if (!this.talkShows) return
        this.latestTalkShows = this.getLatestTalkShows()
      }
    })
  }
}
</script>

<style scoped>
.clickable {
  cursor: pointer;
}

</style>
